import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import * as accounting from 'accounting';

@Component({
  selector: 'app-input-percent',
  templateUrl: './input-percent.component.html',
  styleUrls: ['./input-percent.component.less'],
})
export class InputPercentComponent extends Field {
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  formatterPercent(value: number): string {
    if (value == null || isNaN(value)) {
      value = 0;
    }

    return accounting.formatMoney(
      value,
      '%',
      g.companyConfiguration.PercentDecimal,
      '',
      g.companyConfiguration.DecimalSep,
      '%v %s'
    );
  }
}
